import React, { useState } from "react";
import PrintOrder from "./PrintOrder";
import HeavyPrintOrder from "./HeavyPrintOrder";
import Packing from "./Packing";
import Shipment from "./Shipment";
import Dispatch from "./Dispatch";
import ViewRack from "./ViewRack";
import Barcode from "./Barcode";
import OfflineOrders from "./offlineorderslist";



const WareHouse = () => {
    const [activeTab, setActiveTab] = useState("PrintOrder");

    const tabs = [
        "PrintOrder",
        "HeavyPrintOrder",
        "Packing",
        "Shipment",
        "Dispatch",
        "ViewRack",
        "Barcode",
        "offline orders list"
        // "Create-Spare-Discount",
        // "create-Product-Discount",
        // "Coupons",
        // "Display-Coupons",
        // "Create-All-Discounts",
        // "Create-Free-Product",
        // "Free-Items",
    ];

    return (
        <div style={styles.wrapper}>
            {/* ---------- TABS ---------- */}
            <div style={styles.tabs}>
                {tabs.map((tab) => (
                    <button
                        key={tab}
                        onClick={() => setActiveTab(tab)}
                        style={{
                            ...styles.tabBtn,
                            borderBottom:
                                activeTab === tab ? "2px solid #005487" : "none",
                            color: activeTab === tab ? "#005487" : "#333",
                        }}
                    >
                        {tab}
                    </button>
                ))}
            </div>

            {/* ---------- TAB CONTENT ---------- */}
            {activeTab === "PrintOrder" && <PrintOrder />}
            {activeTab === "HeavyPrintOrder" && <HeavyPrintOrder />}
            {activeTab === "Packing" && <Packing />}
            {activeTab === "Shipment" && <Shipment />}
            {activeTab === "Dispatch" && <Dispatch />}
            {activeTab === "ViewRack" && <ViewRack />}
            {activeTab === "Barcode" && <Barcode />}
            {activeTab === "offline orders list" && <OfflineOrders />}

            {/* {activeTab === "Create-Spare-Discount" && <CreateSpareDiscount/>}
      {activeTab === "create-Product-Discount" && <p>djjjjjsvsvj</p>}
      {activeTab === "Coupons" && <CouponCreation/>}
      {activeTab === "Display-Coupons" && <DisplayCoupons/>}
      {activeTab === "Create-All-Discounts" && <p>djjjjjsvsvj</p>}
      {activeTab === "Create-Free-Product" && <FreeProductForm/>}
      {activeTab === "Free-Items" && <FreeItemsList/>} */}
        </div>
    );
};

export default WareHouse;

/* ---------- STYLES ---------- */
const styles = {
    wrapper: {
        background: "#fff",
        padding: "15px",
        borderRadius: "6px",
    },

    tabs: {
        display: "flex",
        borderBottom: "1px solid #ddd",
        marginBottom: "15px",
        overflowX: "auto",
    },

    tabBtn: {
        background: "none",
        border: "none",
        padding: "10px 16px",
        cursor: "pointer",
        fontWeight: 500,
        whiteSpace: "nowrap",
    },
};
